import { LayoutColors } from '@src/core/theme';
import { BodyExtraSmall } from '@src/fonts/typography/Typography';
import styled from 'styled-components';

interface TextErrorProps {
  $hasError: boolean;
}

export const Title = styled.h2`
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  color: #4d4d4d;
  margin-bottom: 16px;
`;

export const Description = styled.p`
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: #4d4d4d;
  margin-bottom: 16px;
`;

type ValueProps = {
  $center?: boolean;
};

export const Value = styled.p<ValueProps>`
  font-size: 19px;
  font-weight: 700;
  line-height: 23px;
  letter-spacing: 0em;
  text-align: left;
  color: #4d4d4d;
  margin: 16px 0;
  text-align: ${(props) => (props.$center ? 'center' : 'left')};
`;

export const TextError = styled.p<TextErrorProps>`
  ${(props) => (props.$hasError ? '' : 'display: none')};
  ${BodyExtraSmall};
  margin-top: 8px;
  color: ${LayoutColors.errorDark};
`;

export const Instruction = styled.p`
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: #4d4d4d;
  margin-bottom: 16px;
`;

export const CameraInstruction = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 13px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: #4d4d4d;
  margin-bottom: 8px;
`;

export const QRCode = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;

  img {
    width: 150px;
  }
`;

export const TextCode = styled.textarea`
  width: 100%;
  height: 44px;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #999999;
  margin-bottom: 8px;
  resize: none;

  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: #595959;

  &::-webkit-scrollbar-thumb {
    background: ${LayoutColors.blackLight};
    border-radius: 10px;
  }
  &::-webkit-scrollbar {
    width: 9px;
  }
`;

export const VerifyingPayment = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  width: 100%;
  padding: 16px;
  border-radius: 4px;

  background-color: #d6d7f5;
  color: #4d4d4d;
`;
